"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Store = void 0;
const core_1 = require("../core");
const decorators_1 = require("../core/decorators");
let Store = class Store {
    state;
    reducers = {};
    subscription;
    init(state, reducers) {
        this.state = state;
        this.reducers = reducers;
        this.assignSignals();
    }
    assignSignals() {
        for (const [key, value] of Object.entries(this.state || {})) {
            this.subscription = {
                ...this.subscription,
                [key]: (0, core_1.signal)(value),
            };
        }
    }
    updateSignalValues(except) {
        for (const [key, value] of Object.entries(this.subscription || {})) {
            if (except.includes(key)) {
                continue;
            }
            const currentStateValue = this.state[key];
            value.set(currentStateValue, false);
        }
    }
    select(key) {
        return this.subscription[key];
    }
    dispatch(action, payload, emit) {
        const fn = this.reducers[action];
        if (!!fn) {
            const newState = fn(this.state, payload ?? {});
            const prevState = this.state;
            this.state = newState;
            this.updateSignalValues(emit);
            for (const entry of emit) {
                const value = newState[entry];
                const isSame = (typeof value === 'object' &&
                    JSON.stringify(value) === JSON.stringify(prevState[entry])) ||
                    (typeof value !== 'object' && value === prevState[entry]);
                this.select(entry).set(value, !isSame);
            }
            return;
        }
        throw new Error(`Action not found for Store: [${action}]`);
    }
};
exports.Store = Store;
exports.Store = Store = __decorate([
    decorators_1.injectable
], Store);
//# sourceMappingURL=data:application/json;base64,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